import React, { useState } from 'react';
import { Form, Input, Button, Alert, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../utils/api';
import PHOTO from '../assets/login-horse.jpg';

const { Title, Text } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (values) => {
    setLoading(true);
    setError(null);
    try {
      const r = await api.post('/auth/login/', values);
      localStorage.setItem('token', r.data.access);
      localStorage.setItem('refresh', r.data.refresh);
      localStorage.setItem('user', JSON.stringify(r.data.user));
      const from = location.state?.from;
      navigate(from && from !== '/login' ? from : '/', { replace: true });
    } catch (e) {
      const d = e?.response?.data;
      setError(d?.detail || (e?.response ? 'Login failed' : 'Cannot reach the server'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: '#f5f3ef' }}>
      <div
        className="login-photo"
        style={{
          flex: '1 1 55%', position: 'relative', minHeight: '100vh',
          background: `#4a3b2a url(${PHOTO}) center 30% / cover no-repeat`,
        }}
      >
        <div style={{
          position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
          padding: 48, background: 'linear-gradient(to top, rgba(20,14,8,0.75) 0%, rgba(20,14,8,0.15) 45%, rgba(0,0,0,0) 70%)',
        }}>
          <Title style={{ color: '#fff', margin: 0, fontSize: 40 }}>ASHR</Title>
          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 18 }}>Horse &amp; Riding School Management</Text>
        </div>
      </div>
      <div className="login-form-col" style={{ flex: '1 1 45%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, minWidth: 0 }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          <div className="login-brand">
            <Title style={{ color: '#fff', margin: 0, fontSize: 32 }}>ASHR</Title>
            <Text style={{ color: 'rgba(255,255,255,0.9)' }}>Horse &amp; Riding School Management</Text>
          </div>
          <Title level={2} style={{ marginBottom: 4 }}>Welcome back</Title>
          <Text type="secondary">Sign in to continue</Text>
          <div style={{ height: 28 }} />
          {error && <Alert type="error" showIcon message={error} style={{ marginBottom: 16 }} />}
          <Form layout="vertical" onFinish={submit} autoComplete="on">
            <Form.Item name="username" rules={[{ required: true, message: 'Enter your username' }]}>
              <Input prefix={<UserOutlined />} placeholder="Username" size="large" autoFocus autoComplete="username"
                autoCapitalize="none" autoCorrect="off" spellCheck={false} />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: 'Enter your password' }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" autoComplete="current-password" />
            </Form.Item>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}
              style={{ background: '#7a4f2a', borderColor: '#7a4f2a' }}>
              Sign in
            </Button>
          </Form>
        </div>
      </div>
      <style>{`
        .login-brand { display: none; }
        @media (max-width: 760px) {
          .login-photo { display: none; }
          .login-form-col { align-items: flex-start !important; }
          .login-brand {
            display: block; margin: -24px -24px 28px; padding: 96px 24px 20px;
            background: linear-gradient(to top, rgba(20,14,8,0.8), rgba(20,14,8,0.1)), #4a3b2a url(${PHOTO}) center 30% / cover no-repeat;
          }
        }
      `}</style>
    </div>
  );
};

export default Login;
